function teamLang() {
  const langMenu = document.querySelector(".team-header__lang");
  const langButtons = document.querySelectorAll(".lang-item__button");

  if (!langMenu) {
    console.warn("Element with class '.team-header__lang' not found. Exiting teamLang function.");
    return; // Exit the function if langMenu is not found
  }

  // Check if any langButtons exist
  if (langButtons.length === 0) {
    console.warn("No elements with class '.lang-item__button' found. Exiting teamLang function.");
    return; // Exit the function if no langButtons are found
  }
  
    langMenu.addEventListener("focusin", () => {
      langMenu.classList.add("lang--focused");
    });

    document.addEventListener('click', (event) => {
      if (!langMenu.contains(event.target)) {
        langMenu.classList.remove('lang--focused');
      }
    });

    langButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        handleLanguageSwap(event.target);
      });

      button.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          event.preventDefault();
          handleLanguageSwap(event.target);
        }
      });
    });


  function handleLanguageSwap(selectedButton) {
    const activeListItem = langMenu.firstElementChild; 
    const currentActiveButton = activeListItem.querySelector(".lang-item__button");

    if (selectedButton === currentActiveButton) {
      langMenu.classList.remove("lang--focused");
      return;
    }

    const oldActiveText = currentActiveButton.textContent;
    const oldActiveLang = currentActiveButton.dataset.lang;

    currentActiveButton.textContent = selectedButton.textContent;
    currentActiveButton.dataset.lang = selectedButton.dataset.lang;

    selectedButton.textContent = oldActiveText;
    selectedButton.dataset.lang = oldActiveLang;

    langMenu.classList.remove("lang--focused");
  }
}

export { teamLang };
